import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { spanish } from '../../config/config';
import apiMarkdown from '../../api/Markdown';
import Markdown from '../../components/Markdown';

const Privacy = () => {
  const [content, setContent] = useState(null);
  useEffect(async () => {
    setContent(await apiMarkdown.getPrivacy());
  }, []);
  const output = (
    <>
      <Helmet title={spanish ? 'Privacidad' : 'Privacy'} />
      <Markdown data={content} />
    </>
  );
  return output;
};

export default Privacy;
